import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { CiExport } from "react-icons/ci";
import Pagination from "../../Hooks/Pagination";
import { Spinner, Table } from "react-bootstrap";
import { loginActivitiesServices } from "../../APIServices/loginActivitiesServices";

const LogsHistory = () => {
  const [logData, setLogData] = useState([]);
  const [loader, setLoader] = useState(false);

  const getLogRecord = async () => {
    setLoader(true);
    let data = await loginActivitiesServices.getLoginHistoryRecord();
    setLogData(data?.data || []);
    setLoader(false);
  };

  useEffect(() => {
    getLogRecord();
  }, []);

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "login":
        return "green";
      case "logout":
        return "red";
      default:
        return "inherit";
    }
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const result = logData?.slice(startIndex, endIndex);
  const totalPage = Math.ceil(logData?.length / itemsPerPage);

  return (
    <>
      {loader ? (
        <div className="hstack justify-content-center h-75">
          <Spinner />
        </div>
      ) : logData?.length === 0 ? (
        <div className="hstack justify-content-center h-75">
          Data not found!
        </div>
      ) : (
        <>
          <div
            className="border-bottom text-end"
            style={{ padding: "3.2px 10px" }}
          >
            <button
              title="Export"
              className="tabButtons border rounded-1 fs-13"
              style={{ padding: "1px 5px" }}
            >
              <CiExport />
            </button>
          </div>
          <div className="mt-2 px-2 ">
            <div
              className="overflow-auto"
              style={{ maxHeight: "calc(100vh - 200px)" }}
            >
              <Table className="text-nowrap mb-1" hover bordered>
                <thead className="position-sticky" style={{ top: -1 }}>
                  <tr>
                    <th style={{ width: 40 }}>Sr.</th>
                    <th>IP Address</th>
                    <th>Time Zone</th>
                    <th>Location</th>
                    <th style={{ width: 100 }}>Status</th>
                    <th>Activity Type</th>
                    <th style={{ width: 150 }}>IN Out Time</th>
                  </tr>
                </thead>
                <tbody>
                  {result?.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item.ipAddress}</td>
                      <td>{item.timeZone}</td>
                      <td>{item.location}</td>
                      <td>
                        <div style={{ color: getStatusColor(item.status) }}>
                          <b className="text-capitalize">{item.status}</b>
                        </div>
                      </td>
                      <td>{item.activities}</td>
                      <td>
                        <Moment format="DD MMM YYYY | HH:mm">
                          {item.createdAt}
                        </Moment>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <Pagination
              totalPage={totalPage}
              pageNumber={pageNumber}
              itemsPerPage={itemsPerPage}
              totalItems={logData?.length}
              setPageNumber={setPageNumber}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </>
      )}
    </>
  );
};

export default LogsHistory;
